// @auto-index

import './styles.css'
import Background from './Background'

export { default as Background } from './Background'

export default Background
